var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircleLifestyle = function SvgCircleLifestyle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#DAFDD7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#circle_lifestyle_svg__a)",
    fill: "#233E20",
    stroke: "#DAFDD7",
    strokeWidth: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 9C15.729 9 9 15.729 9 24s6.729 15 15 15 15-6.729 15-15S32.271 9 24 9Zm0 28.378c-3.675 0-7.008-1.49-9.428-3.896a13.453 13.453 0 0 1-2.426-3.285A13.296 13.296 0 0 1 10.622 24c0-7.377 6.001-13.378 13.378-13.378 3.499 0 6.688 1.35 9.074 3.557a13.45 13.45 0 0 1 2.996 4.054A13.298 13.298 0 0 1 37.378 24c0 7.377-6.001 13.378-13.378 13.378Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.873 20.595c.596 0 1.116.313 1.386.802.215.393.558.779 1.005.779.448 0 .822-.369.714-.803-.35-1.411-1.61-2.4-3.105-2.4-1.496 0-2.755.989-3.106 2.4-.108.434.266.803.714.803.448 0 .79-.386 1.006-.779.27-.49.79-.802 1.386-.802ZM29.127 20.595c.596 0 1.117.313 1.386.802.215.393.558.779 1.006.779.447 0 .821-.369.713-.803-.35-1.411-1.61-2.4-3.105-2.4-1.495 0-2.755.989-3.105 2.4-.108.434.266.803.713.803.448 0 .79-.386 1.006-.779.27-.49.79-.802 1.386-.802ZM23.971 32.31a9.43 9.43 0 0 0 7.396-3.607c.275-.353.165-.858-.211-1.1-.377-.244-.875-.133-1.157.215a7.78 7.78 0 0 1-6.892 2.821c-1.988-.229-3.845-1.266-5.106-2.82-.282-.349-.78-.46-1.157-.217-.376.243-.486.748-.21 1.1 1.526 1.956 3.823 3.264 6.287 3.548.35.04.701.06 1.05.06Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "circle_lifestyle_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(9 9)",
    d: "M0 0h30v30H0z"
  })))));
};
export default SvgCircleLifestyle;